module.exports = __webpack_public_path__ + "static/media/recharge_voice.aac09c3.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audio/recharge_voice.mp3
// module id = 5Rtn
// module chunks = 1